import { render } from "./BaseIconText.vue?vue&type=template&id=f8bfba9c&ts=true"
import script from "./BaseIconText.vue?vue&type=script&lang=ts"
export * from "./BaseIconText.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__